import { signal } from '@angular/core';
import { PageOptions } from '../types';

export const PAGE_OPTIONS: PageOptions = {
  length: 0,
  pageIndex: 1,
  pageSize: 10,
  pageSizeOptions: [5, 10, 25, 100],
};

export const defaultPageOptions = signal<PageOptions>(PAGE_OPTIONS);
